var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ImageWithAspectRatio", {
    attrs: { ratio: { h: 16, v: 9 } },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(ref) {
          var itemClass = ref.itemClass
          return [_c("img", { class: itemClass, attrs: { src: _vm.src } })]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }